import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import RichTextField from 'components/ContractDialog/MuiRichTextField'

interface DescriptionRichTextProps {
  isOpen: boolean
  onClose: () => void
  onSave: () => void
  description: string
  setDescription: React.Dispatch<React.SetStateAction<string>>
  editingLabel: string
}

const DescriptionRichTextComponent: React.FC<DescriptionRichTextProps> = ({
  isOpen,
  onClose,
  onSave,
  description,
  setDescription,
  editingLabel,
}) => {
  return (
    <Box>
      {isOpen && (
        <Dialog
          open={isOpen}
          onClose={onClose}
          fullWidth
          maxWidth="sm"
          disableEnforceFocus
          disableAutoFocus
          disableRestoreFocus
        >
          <DialogTitle>Edit Description for: {editingLabel}</DialogTitle>

          <DialogContent>
            <Box sx={{ width: '100%', margin: 0 }}>
              <RichTextField content={description || '<p></p>'} onContentChange={setDescription} onBlur={() => {}} />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={onSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  )
}
export default DescriptionRichTextComponent
